module.exports = __webpack_public_path__ + "static/img/Search.3ee0bb79.png";